import { Field } from 'components/Wizards/Field/Field'
import { SourceType } from '../../Types'
import { Audio } from '../../icons/Audio'
import { BlazeDoc } from '../../icons/BlazeDoc'
import { Video } from '../../icons/Video'
import { Website } from '../../icons/Website'
import { Option } from '../Option/Option'
import Styles from './ChooseSourceType.module.scss'

interface Props {
  sourceType: SourceType
  setSourceType: (sourceType: SourceType) => void
}

export const ChooseSourceType = ({ sourceType, setSourceType }: Props) => {
  return (
    <div className={Styles.container}>
      <Field label="Select a content source type" isRequired />
      <div className={Styles.grid}>
        <Option
          isSelected={sourceType === SourceType.Website}
          onChange={() => setSourceType(SourceType.Website)}
          icon={<Website />}
          description="Website"
        />
        <Option
          isSelected={sourceType === SourceType.VideoFile}
          onChange={() => setSourceType(SourceType.VideoFile)}
          icon={<Video />}
          description="Video File"
        />
        <Option
          isSelected={sourceType === SourceType.AudioFile}
          onChange={() => setSourceType(SourceType.AudioFile)}
          icon={<Audio />}
          description="Audio File"
        />
        <Option
          isSelected={sourceType === SourceType.File}
          onChange={() => setSourceType(SourceType.File)}
          icon={<BlazeDoc />}
          description="Blaze Doc"
        />
      </div>
    </div>
  )
}
